import { NodeSpec } from 'prosemirror-model';

import { BaseExtension, PerformanceType } from '@lyearn/lygo-core';

import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class Audio extends BaseExtension {
  get schema(): NodeSpec {
    return {
      attrs: {
        src: {
          default: null,
        },
        file: {
          default: null,
        },
        caption: {
          default: null,
        },
        allowForwarding: {
          default: true,
        },
      },
      group: 'block',
      isAtom: true,
      parseDOM: [
        {
          tag: 'audio',
          getAttrs: (dom: any) => {
            return {
              src: dom.getAttribute('src'),
            };
          },
        },
      ],
      toDOM: (node) => {
        let src = node?.attrs?.src;
        return src
          ? ['div', { class: 'flex justify-center mt-16' }, ['audio', { ...node.attrs }]]
          : ['div'];
      },
    };
  }

  plugins = plugins;

  get name(): string {
    return NODE_NAME;
  }

  get performanceType(): PerformanceType {
    return PerformanceType.BLOCK_BASED;
  }
}
